$(function () {
  function slidersInit() {
    var $prevArrow = $("body .upsell_prev");
    var $nextArrow = $("body .upsell_next");
    var numChildren = $(".oc_review_container").children().length;
    if (numChildren > 1) {
      $("body .oc_review_container").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        adaptiveHeight: true,
        infinite: false,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        loop: false,
      });
    }
  }

  slidersInit();

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      slidersInit();
    });
  }
});
